import React from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="pt-28 pb-12 px-4 bg-white" data-id="element-78">
      <div className="max-w-3xl mx-auto text-center" data-id="element-79">
        <h2 className="text-xl md:text-2xl font-bold text-red-600 mb-6" data-id="element-80">
          Menos pantallas, más abrazos:{' '}
          <span className="font-black" data-id="element-81">
            descubrí el poder del Pack 100 Citas
          </span>
        </h2>

        <button onClick={scrollToPricing} className="w-3/4 max-w-xs md:w-full md:max-w-lg mx-auto block cursor-pointer md:hover:scale-105 transition-transform duration-300 mb-8" data-id="element-82">
          <img src="https://cdn.magicpatterns.com/uploads/eEU2dngs6SQqVMH4fvu1Dx/este.jpg" alt="Pack 100 Citas" className="w-full h-auto rounded-xl" fetchPriority="high" decoding="sync" loading="eager" width={1200} height={800} style={{
          aspectRatio: '3/2',
          objectFit: 'contain'
        }} data-id="element-83" />
        </button>

        <p className="text-lg md:text-xl text-gray-700 mb-8 font-medium max-w-2xl mx-auto" data-id="element-84">
          Descubre el Pack 100 Citas 👨‍👩‍👧‍👦 y vive experiencias únicas con tus
          hijos, pareja o toda la familia. Cada cita 💫 es un momento especial
          que fortalece los lazos, despierta sonrisas y crea recuerdos para
          siempre ❤️.
        </p>

        <div className="max-w-md mx-auto" data-id="element-85">
          <CTAButton text="👉 SÍ, QUIERO LA OFERTA AHORA" size="sm" data-id="element-86" />
          <p className="text-sm text-gray-600 font-medium mt-3" data-id="element-87">
            📥 Descarga Digital Inmediata
          </p>
          <p className="text-sm text-gray-600 mt-2 flex items-center justify-center gap-1" data-id="element-88">
            ✅ Garantía de satisfacción de 7 días
          </p>
        </div>
      </div>
    </section>;
}